import objectMap from '@converdy/utils/object-map'
import overwriteDeep from '@converdy/utils/overwrite-deep'
import parseAlignment from './parsers/parse-alignment'
import parseBackground from './parsers/parse-background'
import parseColor from './parsers/parse-color'
import parseDimension from './parsers/parse-dimension'
import parseOpacity from './parsers/parse-opacity'
import parseFontSize from './parsers/parse-font-size'
import parseGradientBackground from './parsers/parse-gradient-background'
import parseGradientFontColor from './parsers/parse-gradient-font-color'
import parseMargin from './parsers/parse-margin'
import parsePadding from './parsers/parse-padding'
import parseSpacing from './parsers/parse-spacing'
import parseTypography from './parsers/parse-typography'
import parseBorder from './parsers/parse-border'
import parseShadow from './parsers/parse-shadow'
import mapDeep from '@converdy/utils/object-map-deep'

const mapToImportant = mapDeep((e) => {
  if(typeof e === 'string' && e.length > 0) {
    return e + ' !important'
  }
  return e
})

function cCssToJss (parsers) {
  return objectMap(
    cCssObject => {
      return (
        Object.keys(cCssObject)
          .map(
            cCssKey => {
              return parsers[cCssKey](
                cCssObject[cCssKey]
              )
            }
          )
          .reduce(
            (
              jssValueReduction,
              jssValue
            ) => overwriteDeep(
              jssValueReduction,
              jssValue
            ),
            {}
          )
      )
    }
  )
}


export default cCssToJss({
  alignment: parseAlignment,
  background: parseBackground,
  color: parseColor,
  dimension: parseDimension,
  opacity: parseOpacity,
  fontSize: parseFontSize,
  gradientBackground: parseGradientBackground,
  gradientFontColor: parseGradientFontColor,
  margin: parseMargin,
  padding: parsePadding,
  spacing: parseSpacing,
  typography: parseTypography,
  border: parseBorder,
  shadow: parseShadow
})

export const cCssToJssImportant = cCssToJss({
  alignment: (e) => mapToImportant(parseAlignment(e)),
  background:  (e) => mapToImportant(parseBackground(e)),
  // background: parseBackground,
  color: (e) => mapToImportant(parseColor(e)),
  dimension: (e) => mapToImportant(parseDimension(e)),
  opacity: (e) => mapToImportant(parseOpacity(e)),
  fontSize: (e) => mapToImportant(parseFontSize(e)),
  gradientBackground: (e) => mapToImportant(parseGradientBackground(e)),
  gradientFontColor: (e) => mapToImportant(parseGradientFontColor(e)),
  margin: (e) => mapToImportant(parseMargin(e)),
  padding: (e) => mapToImportant(parsePadding(e)),
  spacing: (e) => mapToImportant(parseSpacing(e)),
  typography: (e) => mapToImportant(parseTypography(e)),
  border: (e) => mapToImportant(parseBorder(e)),
  shadow: (e) => mapToImportant(parseShadow(e)),
})
